import ClinicalCalendar from './ClinicalCalendar';
import axios from 'axios';
import React, { useState, useEffect } from 'react';
import Login from './components/Login';
import PushPrompt from './PushPrompt';
import { ensurePushSubscription } from './push';
import NotificationBell from './NotificationBell';
import MyTrainings from './MyTrainings';
import ExecutiveIntelligence from './components/ExecutiveIntelligence';
import CrmDashboard from './components/CrmDashboard';
import LeadIntakeForm from './components/LeadIntakeForm';
import LeadPipeline from './components/LeadPipeline';
import BedBoard from './components/BedBoard';
import URModule from './components/URModule';
import BillingCensus from './components/BillingCensus';
import FinancePlan from './components/FinancePlan';
import Bills from './components/Bills';
import ClientCensusReport from './components/ClientCensusReport';
import ReadyToBill from './components/ReadyToBill';
import ClaimsPage from './components/ClaimsPage';
import RcmDashboard from './components/RcmDashboard';
import WorkQueues from './components/WorkQueues';
import Trackers from './components/Trackers';
import Playbook from './components/Playbook';
import Posting from './components/Posting';
import BillingRules from './components/BillingRules';
import Alumni from './Alumni';
import Collections from './Collections';
import Prescreen from './Prescreen';
import VobHome, { VobJump } from './components/VobHome';
import ReferralROI from './ReferralROI';
import AR from './AR';
import Calls from './Calls';
import Leads from './Leads';
import Queue from './Queue';
import Scorecard from './Scorecard';
import Coaching from './Coaching';
import Users from './Users';
import Roles from './Roles';
import Messages from './Messages';
import Tickets, { ReportIssue } from './Tickets';
import Scheduler from './Scheduler';
import MyShifts from './components/MyShifts';
import Timesheets from './components/Timesheets';
import EmploymentActions from './components/EmploymentActions';
import EmployeeRecords from './components/EmployeeRecords';
import WorkforceCompliance from './components/WorkforceCompliance';
import CensusSync from './CensusSync';
import Lists from './Lists';
import EMR from './EMR';
import Compliance from './Compliance';
import Onboarding from './Onboarding';
import Money from './Money';
import VersionBanner from './components/VersionBanner';
import { tokens } from './theme';
import { TcioLockup, TcioMark, PoweredByGrayscale } from './components/Logos';
const API = 'https://tcio-api.onrender.com';

const ALL_TABS = [
  { key: 'calls',        label: 'Calls',         dept: 'CRM'       , icon: '\u260E\uFE0E' },
  { key: 'intake',       label: 'New Lead',      dept: 'CRM'       , icon: '\u002B\uFE0E' },
  { key: 'pipeline',     label: 'Leads',         dept: 'CRM'       , icon: '▤' },
  { key: 'queue',        label: 'My Queue',      dept: 'CRM'       , icon: '☷' },
  { key: 'scorecard',    label: 'Scorecard',     dept: 'CRM'       , icon: '\u2605\uFE0E' },
  { key: 'coaching',     label: 'Coaching',      dept: 'CRM'       , icon: '◉' },
  { key: 'alumni',       label: 'Alumni',        dept: 'CRM'       , icon: '♢' },
  { key: 'bedboard',     label: 'Bed Board',     dept: 'Clinical'  , icon: '▧' },
  { key: 'prescreen',    label: 'Prescreen',     dept: 'Clinical'  , icon: '\u2713\uFE0E' },
  { key: 'emr',          label: 'EMR',           dept: 'Clinical'  ,   icon: '\u2695\uFE0E' },
  { key: 'clinical-calendar', label: 'Clinical Calendar', dept: 'Clinical'  , icon: '\u25A6' },
  { key: 'vobs',         label: 'VOBs',          dept: 'RCM'       , icon: '⛨' },
  { key: 'ur',           label: 'UR',            dept: 'RCM'       ,   icon: '↺' },
  { key: 'rcm-dashboard', label: 'RCM Dashboard', dept: 'RCM'       ,        icon: '▦' },
  { key: 'ready-to-bill',label: 'Ready to Bill', dept: 'RCM'       ,        icon: '$' },
  { key: 'claims',       label: 'Claims',        dept: 'RCM'       ,        icon: '≣' },
  { key: 'rcm-queues',   label: 'Work Queues',   dept: 'RCM'       ,        icon: '☷' },
  { key: 'rcm-posting',  label: 'Posting',       dept: 'RCM'       ,        icon: '¤' },
  { key: 'billing-rules',label: 'Billing Rules', dept: 'RCM'       ,        icon: '⚙' },
  { key: 'rcm-trackers', label: 'Trackers',      dept: 'RCM'       ,        icon: '➚' },
  { key: 'rcm-playbook', label: 'Playbook',      dept: 'RCM'       ,        icon: '≡' },
  { key: 'billing-census', label: 'Weekly Billing Census', dept: 'RCM'       , icon: '▦' },
  { key: 'money',        label: 'Money',         dept: 'Finance'   ,    icon: '¤' },
  { key: 'finance-plan', label: 'Plan & Pace', dept: 'Finance'   , icon: '%' },
  { key: 'finance-bills', label: 'Bills', dept: 'Finance'   , icon: '\u2261' },
  { key: 'reports',      label: 'Reports',       dept: 'Finance'   ,    icon: '▥' },
  { key: 'collections',  label: 'Collections',   dept: 'Finance'   ,    icon: '◍' },
  { key: 'ar',           label: 'AR',            dept: 'Finance'   ,    icon: '≣' },
  { key: 'referral-roi', label: 'Referral ROI',  dept: 'Growth'    ,     icon: '➚' },
  { key: 'scheduler',    label: 'Scheduler',     dept: 'Operations', icon: '▦' },
  { key: 'workforce',    label: 'Workforce',     dept: 'HR'        ,         icon: '▦' },
  { key: 'my-shifts',    label: 'My Workday',    dept: 'HR'        ,         icon: '◔' },
  { key: 'timesheets',   label: 'Timesheets',    dept: 'HR'        ,         icon: '◷' },
  { key: 'employment',   label: 'Employment',    dept: 'HR'        ,         icon: '⎘' },
  { key: 'messages',     label: 'Messages',      dept: 'Communication', icon: '\u2709\uFE0E' },
  { key: 'home',         label: 'Home',          dept: 'Admin'     ,      icon: '\u2302\uFE0E' },
  { key: 'dashboard',    label: 'Executive',     dept: 'Admin'     ,      icon: '▦' },
  { key: 'compliance',   label: 'Compliance',    dept: 'Admin'     ,      icon: '\u2691\uFE0E' },
  { key: 'lists',        label: 'Staff & Lists', dept: 'Admin'     ,      icon: '\u270E\uFE0E' },
  { key: 'users',        label: 'Users',         dept: 'Admin'     ,      icon: '\u263A\uFE0E' },
  { key: 'roles',        label: 'Roles',         dept: 'Admin'     ,      icon: '\u263A\uFE0E' },
  { key: 'tickets',      label: 'Tickets',       dept: 'Admin'     ,      icon: '\u2709\uFE0E' },
  { key: 'onboarding',   label: 'Onboarding',    dept: 'Admin'     ,      icon: '\u27A4\uFE0E' },
  { key: 'census-sync',  label: 'Census Sync',   dept: 'Admin'     ,      icon: '⇄' },
];

const DEPT_ORDER = ['CRM', 'Clinical', 'RCM', 'Finance', 'Growth', 'Operations', 'HR', 'Communication', 'Admin'];

// Unread messages watcher - polls every 15s, chimes + toasts when unread grows,
// and reports the live count up to App for the nav badge. Pauses while the
// Messages view is open (that view runs its own poll and marks reads).
function playMsgChime() {
  try {
    const Ctx = window.AudioContext || window.webkitAudioContext;
    if (!Ctx) return;
    const ctx = new Ctx();
    const o = ctx.createOscillator(), g = ctx.createGain();
    o.type = 'sine'; o.frequency.setValueAtTime(880, ctx.currentTime);
    o.frequency.setValueAtTime(1174.66, ctx.currentTime + 0.12);
    g.gain.setValueAtTime(0.12, ctx.currentTime);
    g.gain.exponentialRampToValueAtTime(0.0001, ctx.currentTime + 0.45);
    o.connect(g); g.connect(ctx.destination);
    o.start(); o.stop(ctx.currentTime + 0.5);
    setTimeout(() => ctx.close().catch(() => {}), 700);
  } catch (e) { /* audio blocked until first user interaction - fine */ }
}
function MsgToast({ user, open, paused, onCount }) {
  const [count, setCount] = useState(0);
  const [show, setShow] = useState(false);
  const lastRef = React.useRef(null);
  useEffect(() => {
    if (!user) return;
    let dead = false;
    const check = async () => {
      if (paused) return;
      try {
        const r = await axios.get(API + '/api/msg/threads');
        const n = (r.data || []).reduce((a, x) => a + Number(x.unread || 0), 0);
        if (dead) return;
        setCount(n);
        if (onCount) onCount(n);
        const prev = lastRef.current;
        lastRef.current = n;
        if (prev === null) {
          if (n > 0) { setShow(true); setTimeout(() => !dead && setShow(false), 8000); }
        } else if (n > prev) {
          playMsgChime();
          setShow(true); setTimeout(() => !dead && setShow(false), 8000);
        }
      } catch (e) { /* messenger not granted or api down - stay silent */ }
    };
    const t = setTimeout(check, 1200);
    const iv = setInterval(check, 15000);
    return () => { dead = true; clearTimeout(t); clearInterval(iv); };
  }, [user, paused, onCount]);
  if (!show) return null;
  return (
    <div onClick={() => { setShow(false); open(); }}
      style={{ position: 'fixed', top: 68, right: 18, zIndex: 1200, background: tokens.surface,
        border: '1px solid ' + tokens.border, borderLeft: '4px solid ' + tokens.ai,
        borderRadius: tokens.radiusCard, boxShadow: tokens.shadow, padding: '12px 16px',
        cursor: 'pointer', fontFamily: tokens.font }}>
      <div style={{ fontSize: 13, fontWeight: 700, color: tokens.ink }}>
        You have {count} unread message{count === 1 ? '' : 's'}</div>
      <div style={{ fontSize: 11.5, color: tokens.ai, fontWeight: 600, marginTop: 2 }}>Open Messages</div>
    </div>
  );
}

function App() {
  const [user, setUser]   = useState(null);
  const [view, setView]   = useState(null);
  const [prevView, setPrevView] = useState(null);
  const go = (next) => { setView(v => { if (v && v !== next) setPrevView(v); return next; }); };
  const [menuOpen, setMenuOpen] = useState(false);
  const [navCollapsed, setNavCollapsed] = useState(() => localStorage.getItem('tcio_nav_collapsed') === '1');
  const toggleNav = () => { setNavCollapsed(c => { const n = !c; localStorage.setItem('tcio_nav_collapsed', n ? '1' : '0'); if (n) setMenuOpen(false); return n; }); };
  const [loading, setLoading] = useState(true);
  const [mobileNav, setMobileNav] = useState(false);
  const [msgUnread, setMsgUnread] = useState(0);

  // On mount: check for saved token
  useEffect(() => {
    const token = localStorage.getItem('tcio_token');
    if (token) {
      fetch(`${API}/api/auth/me`, {
        headers: { Authorization: `Bearer ${token}` }
      })
        .then(r => r.json())
        .then(data => {
          if (data.ok) {
            axios.defaults.headers.common.Authorization = `Bearer ${token}`;
            setUser({ ...data.user, token });
            setView(window.location.hash.startsWith('#/lead/') && data.user.tabs.includes('pipeline') ? 'pipeline' : (['dashboard','home'].find(t => data.user.tabs.includes(t)) || data.user.tabs[0]));
          } else {
            localStorage.removeItem('tcio_token');
          }
          setLoading(false);
        })
        .catch(() => {
          localStorage.removeItem('tcio_token');
          setLoading(false);
        });
    } else {
      setLoading(false);
    }
  }, []);

  function handleLogin(data) {
    localStorage.setItem('tcio_token', data.token);
    localStorage.setItem('tcio_emr_perms', JSON.stringify((data.user && data.user.emr_permissions) || {}));
    localStorage.setItem('tcio_role', (data.user && data.user.role) || ''); // read by UR auth delete, CQI lead, misses ack, compliance waive — was never written
    axios.defaults.headers.common.Authorization = `Bearer ${data.token}`;
    setUser({ ...data.user, token: data.token });
    setView(window.location.hash.startsWith('#/lead/') && data.user.tabs.includes('pipeline') ? 'pipeline' : (['dashboard','home'].find(t => data.user.tabs.includes(t)) || data.user.tabs[0]));
    ensurePushSubscription().catch(() => {});   // re-register this device if notifications are already on
  }

  // TENANT SWITCHER (2026-09-11): orgWide roles pick which tenant world they're in.
  // Hooks live above every early return (rules-of-hooks); the effect self-gates.
  const [tenants, setTenants] = useState([]);
  const [activeTenant, setActiveTenant] = useState(null);
  const [homeTenant, setHomeTenant] = useState(null);
  useEffect(() => {
    if (!user || !(['ceo','admin','hr'].includes(user.role) || user.can_see_sandbox === true)) return; // HR sees its own tenants; a sandbox login gets home + sandbox (server decides which)
    fetch(`${API}/api/tenants`, { headers: { Authorization: `Bearer ${user.token || localStorage.getItem('tcio_token')}` } })
      .then(r => r.json())
      .then(j => { if (j.ok) { setTenants(j.data || []); setActiveTenant(j.active); setHomeTenant(j.home); } })
      .catch(() => {});
  }, [user]);
  const switchTenant = (id) => {
    if (id && id !== 'sandbox' && !/^[0-9a-f-]{36}$/i.test(id)) return;
    localStorage.setItem('tcio_active_tenant', id);
    window.location.reload();
  };
  const viewingAway = activeTenant && homeTenant && activeTenant !== homeTenant;

  function handleLogout() {
    localStorage.removeItem('tcio_token');
    delete axios.defaults.headers.common.Authorization;
    setUser(null);
    setView(null);
  }

  if (loading) {
    return (
      <div style={{ minHeight: '100vh', background: '#0f1623', display: 'flex', alignItems: 'center', justifyContent: 'center', color: '#7a9cc4', fontSize: '14px', letterSpacing: '0.1em' }}>
        LOADING...
      </div>
    );
  }

  if (!user) return <Login onLogin={handleLogin} />;

  const visibleTabs = ALL_TABS.filter(t => user.tabs?.includes(t.key));

  const isMobile = typeof window !== 'undefined' && window.innerWidth < 768;
  const SIDE_W = navCollapsed ? 76 : 224;

  const SidebarNav = ({ collapsed, onNavigate }) => (
    <>
      <div style={{ padding: collapsed ? '16px 0 14px' : '18px 16px 16px', display: 'flex', justifyContent: collapsed ? 'center' : 'flex-start' }}>
        {collapsed ? <TcioMark size={34} /> : <TcioLockup height={46} tone="light" />}
      </div>
      {!collapsed && tenants.length > 1 && (
        <div style={{ padding: '0 16px 14px' }}>
          <select value={activeTenant || ''} onChange={e => switchTenant(e.target.value)}
            title="Switch tenant - changes which company's world you are viewing"
            style={{ width: '100%', padding: '7px 10px', borderRadius: 8, fontSize: 12, fontWeight: 600,
                     fontFamily: tokens.font, cursor: 'pointer', color: '#fff',
                     background: viewingAway ? 'rgba(233,154,24,0.22)' : 'rgba(255,255,255,0.08)',
                     border: viewingAway ? '1.5px solid #E99A18' : '1px solid rgba(255,255,255,0.18)' }}>
            {tenants.map(t => <option key={t.id} value={t.id} style={{ color: '#22303E' }}>{t.name}{t.id === homeTenant ? ' (home)' : ''}</option>)}
          </select>
          {viewingAway && (
            <div style={{ marginTop: 6, fontSize: 10, fontWeight: 700, color: '#E99A18', textTransform: 'uppercase', letterSpacing: '0.08em' }}>
              Viewing another tenant
            </div>
          )}
        </div>
      )}
      <div style={{ flex: 1, overflowY: 'auto', padding: collapsed ? '4px 12px' : '4px 12px' }}>
        {DEPT_ORDER.map(dept => {
          const group = visibleTabs.filter(t => t.dept === dept);
          if (group.length === 0) return null;
          return (
            <div key={dept} style={{ marginBottom: 14 }}>
              {!collapsed && (
                <div style={{ fontSize: 9.5, fontWeight: 700, color: 'rgba(255,255,255,0.38)', textTransform: 'uppercase', letterSpacing: '0.13em', padding: '0 10px', marginBottom: 4 }}>{dept}</div>
              )}
              {group.map(item => {
                const on = view === item.key;
                return (
                  <button key={item.key} title={item.label}
                    onClick={() => { go(item.key); if (onNavigate) onNavigate(); }}
                    style={{ display: 'flex', alignItems: 'center', gap: 10, width: '100%',
                      justifyContent: collapsed ? 'center' : 'flex-start',
                      background: on ? 'rgba(8,120,232,0.18)' : 'none', border: 'none',
                      boxShadow: on ? 'inset 3px 0 0 ' + tokens.ai : 'none',
                      color: on ? '#FFFFFF' : 'rgba(255,255,255,0.66)', borderRadius: 8,
                      padding: collapsed ? '10px 0' : '7.5px 10px', cursor: 'pointer',
                      fontSize: 13, fontWeight: on ? 650 : 500, textAlign: 'left', fontFamily: tokens.font }}>
                    <span style={{ width: 17, textAlign: 'center', fontSize: 14, opacity: 0.9, flex: 'none' }}>{item.icon}</span>
                    {!collapsed && item.label}
                    {item.key === 'messages' && msgUnread > 0 && (
                      <span style={{ marginLeft: collapsed ? 0 : 'auto', background: '#DC2626', color: '#fff',
                        borderRadius: 9, fontSize: 10, fontWeight: 700, padding: '1px 6px', flex: 'none' }}>{msgUnread}</span>
                    )}
                  </button>
                );
              })}
            </div>
          );
        })}
      </div>
      <div style={{ padding: collapsed ? '12px 0 14px' : '12px 18px 14px', borderTop: '1px solid rgba(255,255,255,0.08)', display: 'flex', justifyContent: collapsed ? 'center' : 'flex-start' }}>
        <PoweredByGrayscale tone="light" collapsed={collapsed} />
      </div>
    </>
  );

  const initials = (user.name || '?').split(' ').map(w => w[0]).filter(Boolean).slice(0, 2).join('').toUpperCase();

  return (
    <div style={{ minHeight: '100vh', backgroundColor: tokens.canvas, fontFamily: tokens.font, display: 'flex' }}>

      {/* ── NAVY SIDEBAR (desktop) ── */}
      {!isMobile && (
        <div style={{ width: SIDE_W, flex: 'none', background: tokens.navy900, minHeight: '100vh',
          position: 'sticky', top: 0, alignSelf: 'flex-start', height: '100vh',
          display: 'flex', flexDirection: 'column', transition: 'width 0.15s ease' }}>
          <SidebarNav collapsed={navCollapsed} />
          <button onClick={toggleNav} title={navCollapsed ? 'Expand menu' : 'Collapse menu'}
            style={{ background: 'none', border: 'none', color: 'rgba(255,255,255,0.45)', cursor: 'pointer',
              fontSize: 13, padding: '10px 0 14px', fontFamily: tokens.font }}>
            {navCollapsed ? '\u203A' : '\u2039 Collapse'}
          </button>
        </div>
      )}

      {/* ── MOBILE OFF-CANVAS ── */}
      {isMobile && mobileNav && (
        <div onClick={() => setMobileNav(false)}
          style={{ position: 'fixed', inset: 0, background: 'rgba(7,26,45,0.55)', zIndex: 300 }}>
          <div onClick={e => e.stopPropagation()}
            style={{ width: 248, height: '100%', background: tokens.navy900, display: 'flex', flexDirection: 'column' }}>
            <SidebarNav collapsed={false} onNavigate={() => setMobileNav(false)} />
          </div>
        </div>
      )}

      {/* ── MAIN COLUMN ── */}
      <div style={{ flex: 1, minWidth: 0 }}>

        {/* ── WHITE COMMAND BAR ── */}
        <div style={{ background: tokens.surface, borderBottom: '1px solid ' + tokens.border,
          padding: '0 18px', display: 'flex', alignItems: 'center', gap: 14,
          position: 'sticky', top: 0, zIndex: 100, height: 56 }}>
          {isMobile && (
            <button onClick={() => setMobileNav(true)}
              style={{ background: 'none', border: 'none', fontSize: 20, color: tokens.ink, cursor: 'pointer' }}>☰</button>
          )}
          {isMobile && <TcioMark size={26} />}
          {prevView && prevView !== view && (
            <button onClick={() => go(prevView)} title="Back to previous screen"
              style={{ background: tokens.surfaceSoft, border: '1px solid ' + tokens.border, color: tokens.textSecondary,
                borderRadius: 999, padding: '4px 13px', fontSize: 12, fontWeight: 600, cursor: 'pointer', whiteSpace: 'nowrap', fontFamily: tokens.font }}>‹ Back</button>
          )}
          <div style={{ flex: 1, maxWidth: 520, position: 'relative' }}>
            <input readOnly value="" placeholder={'\u2726  Ask TCIO anything\u2026'}
              onClick={() => alert('Ask TCIO is coming soon \u2014 it will answer from your live TCIO data.')}
              style={{ width: '100%', boxSizing: 'border-box', background: tokens.surfaceSoft,
                border: '1px solid ' + tokens.border, borderRadius: 10, padding: '9px 13px',
                fontSize: 13, color: tokens.textSecondary, cursor: 'pointer', fontFamily: tokens.font }} />
            {!isMobile && <span style={{ position: 'absolute', right: 11, top: 9, fontSize: 11, color: tokens.textMuted,
              border: '1px solid ' + tokens.border, borderRadius: 5, padding: '1px 6px', background: tokens.surface }}>⌘K</span>}
          </div>
          <div style={{ marginLeft: 'auto', display: 'flex', alignItems: 'center', gap: 12 }}>
            {!isMobile && <div style={{ textAlign: 'right', lineHeight: 1.2 }}>
              <div style={{ fontSize: 13, fontWeight: 600, color: tokens.ink }}>{user.name}</div>
              <div style={{ fontSize: 10.5, textTransform: 'uppercase', letterSpacing: '0.08em', color: tokens.textMuted }}>{user.role?.replace('_', ' ')}</div>
            </div>}
            <div style={{ width: 34, height: 34, borderRadius: '50%', background: tokens.ai, color: '#fff',
              display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 13, fontWeight: 700 }}>{initials}</div>
            <MyTrainings tokens={tokens} />
            <NotificationBell tokens={tokens} />
            <button onClick={handleLogout}
              style={{ background: tokens.surface, border: '1px solid ' + tokens.border, color: tokens.textSecondary,
                padding: '6px 13px', borderRadius: 8, cursor: 'pointer', fontSize: 12, fontFamily: tokens.font }}>Sign Out</button>
          </div>
        </div>

      <VersionBanner />
      <PushPrompt />
      {view === 'home'        && <CrmDashboard user={user} nav={setView} />}
      {view === 'dashboard'   && <ExecutiveIntelligence user={user} nav={setView} />}
      {view === 'bedboard'    && <BedBoard user={user} />}
      {view === 'ur'          && <URModule user={user} />}
      {view === 'pipeline'    && <Leads user={user} />}
      {view === 'intake'      && <LeadIntakeForm user={user} onCreated={() => setView('pipeline')} onCancel={() => setView('pipeline')} />}
      {view === 'billing-census' && <BillingCensus user={user} />}
      {view === 'finance-plan' && <FinancePlan user={user} />}
      {view === 'finance-bills' && <Bills user={user} />}
      {view === 'reports'     && <ClientCensusReport user={user} />}
      {view === 'ready-to-bill' && <ReadyToBill user={user} />}
      {view === 'rcm-dashboard' && <RcmDashboard user={user} nav={go} />}
      {view === 'claims' && <ClaimsPage user={user} />}
      {view === 'rcm-queues' && <WorkQueues user={user} nav={go} />}
      {view === 'rcm-posting' && <Posting user={user} nav={go} />}
      {view === 'billing-rules' && <BillingRules user={user} />}
      {view === 'rcm-trackers' && <Trackers user={user} nav={go} />}
      {view === 'rcm-playbook' && <Playbook user={user} nav={go} />}
      {[].includes(view) && (
        <div style={{ padding: 28, maxWidth: 720 }}>
          <h2 style={{ margin: 0 }}>{({ 'rcm-dashboard':'RCM Dashboard', claims:'Claims', 'rcm-queues':'Work Queues', 'rcm-posting':'Posting', 'billing-rules':'Billing Rules', 'rcm-trackers':'Trackers' })[view]}</h2>
          <p style={{ opacity: .7, marginTop: 8 }}>Building now — this page replaces its placeholder as each RCM phase ships. Nothing existing is retired until then.</p>
        </div>
      )}
      {view === 'collections' && <Collections user={user} />}
      {view === 'alumni'      && <Alumni user={user} />}
      {view === 'referral-roi' && <ReferralROI user={user} />}
      {view === 'prescreen' && <Prescreen user={user} />}
      {view === 'vobs' && <VobHome user={user} />}
        <VobJump go={go} />
      {view === 'ar' && <AR token={user.token} />}
      {view === 'calls' && <Calls user={user} />}
      {view === 'queue' && <Queue user={user} />}
      {view === 'scorecard' && <Scorecard user={user} nav={setView} />}
      {view === 'lists' && <Lists user={user} />}
      {view === 'emr' && <EMR user={user} nav={setView} />}
      {view === 'compliance' && <Compliance user={user} />}
      {view === 'onboarding' && <Onboarding user={user} />}
      {view === 'money' && <Money user={user} />}
      {view === 'coaching' && <Coaching user={user} />}
      {view === 'users' && <Users user={user} />}
      {view === 'roles' && <Roles user={user} />}
      {view === 'messages' && <Messages user={user} nav={setView} />}
      {view === 'tickets' && <Tickets user={user} />}
      {view === 'scheduler' && <Scheduler user={user} />}
      {view === 'clinical-calendar' && <ClinicalCalendar user={user} />}
      {view === 'my-shifts' && <MyShifts user={user} />}
      {view === 'timesheets' && <Timesheets user={user} />}
      {view === 'employment' && <EmploymentActions user={user} />}
      {view === 'employee-records' && <EmployeeRecords user={user} />}
      {view === 'workforce' && <WorkforceCompliance user={user} nav={setView} />}
      {view === 'census-sync' && <CensusSync user={user} />}
      </div>
      <ReportIssue user={user} />
      <MsgToast user={user} open={() => go('messages')} paused={view === 'messages'} onCount={setMsgUnread} />
    </div>
  );
}

export default App;